import * as React from 'react'

export const Trash = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9.75 3V2.75C9.75 1.8125 8.9375 1 8 1C7.03125 1 6.25 1.8125 6.25 2.75V3H3H2V4H3V14C3 14.5523 3.44772 15 4 15H12C12.5523 15 13 14.5523 13 14V4H14V3H13H9.75ZM8.75 3V2.75C8.75 2.34375 8.40625 2 8 2C7.5625 2 7.25 2.34375 7.25 2.75V3H8.75ZM4 13.5V4H12V13.5C12 13.7761 11.7761 14 11.5 14H4.5C4.22386 14 4 13.7761 4 13.5ZM7 6H6V12H7V6ZM9 6H10V12H9V6Z"
  />
)
